// This file was automatically generated from appchart.dialog.viewInlineCda.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.viewInlineCda');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.viewInlineCda.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="dialog-header">');
  el8.template.appchart.dialog.viewInlineCda.buttonSection(opt_data, output);
  output.append('<div class="imported-section-list"></div></div><iframe sandbox="" seamless width="100%"></iframe>');
  if (! opt_data.signDate && el8Globals.USER_STAFF_TYPE == 'OfficeStaff' && opt_data.physicianUsers) {
    output.append('<div class="select-physician-section el8DialogFileBar"><span class="el8StandardFontSize padr10">File on behalf of:</span><select name="physicianUser" class="w50">');
    var uList2891 = opt_data.physicianUsers;
    var uListLen2891 = uList2891.length;
    for (var uIndex2891 = 0; uIndex2891 < uListLen2891; uIndex2891++) {
      var uData2891 = uList2891[uIndex2891];
      output.append('<option value="', soy.$$escapeHtml(uData2891.id), '">', soy.$$escapeHtml(uData2891.name), '</option>');
    }
    output.append('</select></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.viewInlineCda.buttonSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.signDate) {
    if (! opt_data.isQRDA_1) {
      output.append('<div class="import-button-section el8ButtonGroupContainerDark"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><p class="el8Bold ml10">Import:</p></li>');
      el8.template.appchart.dialog.viewInlineCda._button({sectionName: 'All'}, output);
      el8.template.appchart.dialog.viewInlineCda._button({sectionName: 'Allergies'}, output);
      el8.template.appchart.dialog.viewInlineCda._button({sectionDisplayName: 'Demographics', sectionName: 'demographics_complete'}, output);
      el8.template.appchart.dialog.viewInlineCda._button({sectionName: 'Immunizations'}, output);
      el8.template.appchart.dialog.viewInlineCda._button({sectionName: 'Medications'}, output);
      el8.template.appchart.dialog.viewInlineCda._button({sectionName: 'Problems'}, output);
      output.append('</ul></div>');
    }
  } else {
    output.append('<div class="import-button-section el8ButtonGroupContainerAlert"><div class="el8ButtonContainer">', (opt_data.isQRDA_1) ? '<p class="el8Bold el8AlignCenter">Sign off this QRDA file to incorporate quality reporting data into this patient\'s quality measure calculations.</p>' : '<p class="el8Bold el8AlignCenter">Sign off this Summary of Care Document to be able to import individual sections.</p><p class="el8Bold el8AlignCenter"><a href="' + soy.$$escapeHtml(opt_data.validateUrl) + '" target="_blank" rel="noopener noreferrer">Click here to see if there are any validation errors.</a></p>', (opt_data.isCCR) ? '<p class="el8Bold el8AlignCenter">Clicking "Sign Off &amp; Import All" will also import encounters for CCRs.</p>' : '', '</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.viewInlineCda.importedSectionList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isCCR) ? '<div class="el8ButtonGroupContainerAlert"><p class="el8Bold el8AlignCenter">Clicking "Import: All" will also import encounters for CCRs.</p></div>' : '');
  if (opt_data.importedSections.length) {
    output.append('<p class="el8ImportList">Imported ');
    var sectionList2939 = opt_data.importedSections;
    var sectionListLen2939 = sectionList2939.length;
    for (var sectionIndex2939 = 0; sectionIndex2939 < sectionListLen2939; sectionIndex2939++) {
      var sectionData2939 = sectionList2939[sectionIndex2939];
      output.append(soy.$$escapeHtml(sectionData2939), (! (sectionIndex2939 == sectionListLen2939 - 1)) ? ', ' : '');
    }
    output.append('</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.viewInlineCda._button = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8ButtonItem"><button type="button" class="el8button ', (opt_data.sectionName == 'All') ? 'import-all-trigger' : 'import-reconcile-section-trigger', '" data-section="', soy.$$escapeHtml(opt_data.sectionName), '">', (opt_data.sectionDisplayName) ? soy.$$escapeHtml(opt_data.sectionDisplayName) : soy.$$escapeHtml(opt_data.sectionName), '</button></li>');
  if (!opt_sb) return output.toString();
};
